import React from "react";
import { Show, SimpleShowLayout, TextField } from "react-admin";

export const ShowComponent: React.FC = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="Id" source="id" />
      <TextField label="Name" source="name" />
      <TextField label="Email" source="email" />
      <TextField source="created_at" />
      <TextField source="updated_at" />
    </SimpleShowLayout>
  </Show>
);
